"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var delete_1 = tslib_1.__importDefault(require("../../icons/delete"));
var __1 = tslib_1.__importDefault(require("../"));
var DeleteButton = function (_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (react_1.default.createElement(__1.default, tslib_1.__assign({ icon: delete_1.default, className: "danger-bg " + className }, props)));
};
DeleteButton.defaultProps = {
    size: 32,
};
exports.default = DeleteButton;
//# sourceMappingURL=index.js.map